import { NewsAndOffersType } from '@/features/news-and-offers/types/news-and-offers-dto';
import NewsIconSolid from '@/components/icons/NewsIconSolid';
import SaleTag_02_IconSolid from '@/components/icons/SaleTag_02_IconSolid';
import { t } from 'i18next';

const getCardIcon = (option: NewsAndOffersType) => {
  switch (option) {
    case NewsAndOffersType.News:
      return {
        label: 'main.newsAndOffers.types.news',
        icon: NewsIconSolid,
        className: 'fill-warning-1000',
      };
    case NewsAndOffersType.Offers:
      return {
        label: 'main.newsAndOffers.types.offers',
        icon: SaleTag_02_IconSolid,
        className: 'fill-error-1000',
      };
  }
};

export const newsAndOffersConfig = {
  getCardIcon,
};